import React from 'react';
import { FlexContainer, Image, Title } from '../common/StyledComponents';

import followOnTwitter from '../../assets/images/follow-on-twitter.png';

const AuthorInfo = props => {
  // console.log('props: ', props);
  const {
    user_info: { image, displayName, description },
    user_posts: { postCount }
  } = props;
  return (
    <FlexContainer
      className="AuthorInfo bg-white mb3"
      justifycontent="space-evenly"
      style={{ maxWidth: '726px', padding: '1.5rem' }}
    >
      <FlexContainer
        className="left-half"
        justifycontent="center"
        alignitems="center"
        width={'108px'}
      >
        <Image
          className="author-image"
          src={image}
          alt={displayName}
          width="108px"
          height="108px"
        />
      </FlexContainer>
      <FlexContainer
        className="right-half pl3"
        direction="column"
        width={'calc(100% - 108px)'}
      >
        <Title
          className="author-name"
          fontFamily="Montserrat"
          fontSize="1.5rem"
          color="#212121"
        >
          {displayName}
        </Title>
        <Title
          className="author-about"
          fontFamily="Montserrat"
          fontSize="0.875rem"
          lineHeight="1.4"
          color="#212121"
          padding="0.5rem 0.5rem 1rem 0"
          style={{ textAlign: 'justify' }}
        >
          {description}
        </Title>
        <FlexContainer
          className="total-and-sharing"
          justifycontent="space-between"
          alignitems="center"
        >
          <FlexContainer
            className="total"
            direction="column"
            alignitems="center"
          >
            <Title
              fontFamily="Montserrat"
              fontSize="0.875rem"
              lineheight="20px"
              color="#757575"
            >
              Total Posts
            </Title>
            <Title fontFamily="Montserrat" fontSize="1.5rem" color="#212121">
              {postCount}
            </Title>
          </FlexContainer>
          <FlexContainer className="sharing">
            <Image
              className="twitter"
              src={followOnTwitter}
              alt={followOnTwitter}
              width="143px"
              height="42px"
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AuthorInfo;
